import { jsx as _jsx } from "react/jsx-runtime";
import { GridContainer } from './container';
import { Grid } from './grid';
export const ContainedGrid = ({ type, className, ...other }) => (_jsx(GridContainer, { className, type, children: _jsx(Grid, { ...other }) }));
ContainedGrid.displayName = 'ContainedGrid';
//# sourceMappingURL=contained-grid.js.map